import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/landgrave1687.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series I volume 4</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 414-415<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
    Date: January 1687<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (78k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Landgrave Ernst von Hessen-Rheinfels (9 (?) January 1687)</title>
            <meta name="description" content="An English translation of LETTER TO LANDGRAVE ERNST VON HESSEN-RHEINFELS by Gottfried Wilhelm Leibniz, written 9 JANUARY 1687" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO LANDGRAVE ERNST VON HESSEN-RHEINFELS</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A I 4, 414</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Extract from my letter on this point<br /><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The letter from Rome must have been written by a very learned and judicious person. It is certain that some mystics fall into illusions: consider Valentin Weigel,<a name="1" href="#note1"><sup>1</sup></a> Antoinette de Bourignon,<a name="2" href="#note2"><sup>2</sup></a> and Jakob Boehme,<a name="3" href="#note3"><sup>3</sup></a> the Lusatian craftsman who had a very elevated mind, and whose expressions are admired by learned people to the extent that even [<b>A I 4, 415</b>] Princess Elisabeth - sister of the late Charles Louis, Elector Palatine - who was one of the most discriminating people in the world, nonetheless found something agreeable in him, and yet I think that this craftsman often did not understand himself. Father Schorrer, a Jesuit from Bavaria, tried to reduce mystical theology to the form of science or well-ordered doctrine,<a name="4" href="#note4"><sup>4</sup></a> which would be best in order to purge it of the thousand allegorical expressions which contain more splendour than solidity. I have not yet seen anything by either Dr Molinos or Monseigneur (now Cardinal) Petrucci,<a name="5" href="#note5"><sup>5</sup></a> but as I understand that their doctrine was defended by Monseigneurs Ricci and Favoriti,<a name="6" href="#note6"><sup>6</sup></a> who were two of the most learned and enlightened people Rome has had in our time, I imagine that there is something very good in it, and that if there was anything bad mixed in then it must have been extremely well hidden. If quietude extends only to the contemplation of the eternal truths contained in the divine perfections, and to a constant apprehension of the infinitely perfect being insofar as it is such, without any regard for our own individual interest and for worldly things, there is nothing to criticize. For in effect the mental vision which accompanies an act of love of God above all things is only that. So the method of quietude taken in this sense would be nothing but a spiritual device for making the act of divine love last longer than usual, an act commended to us by Jesus Christ and by theologians, mystics and others, and which is the most essential point of our religion. And I do not see how one can criticize those who propose legitimate ways to elevate a well-prepared soul to more eminent degrees of spiritual perfection. But to claim that the soul in this state of contemplation is able to abandon its body to do wicked actions would be a ridiculous abuse of a good doctrine, and I don't think that Monseigneur Petrucci is capable of that. And although the supreme love of God above all things, taken precisely in itself, considers God only as infinitely perfect, and not at all as dwelling in the humanity of Jesus Christ - such that everything which concerns Jesus Christ as man cannot enter into the mental vision essential to the act of supreme love - it nevertheless can and must be said that the consideration of the benefits God has given to us in Jesus Christ is the greatest preparation for the grace of divine love, inasmuch as the promise of the unction of the Holy Spirit is attached to it. 
                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />
                        NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> Valentin Weigel (1533-1588), German theologian and mystical writer.<br />
                        <a name="note2" href="#2">2.</a> Antoinette de Bourignon (1616-1680), Flemish mystic.<br />
                        <a name="note3" href="#3">3.</a> Jakob Boehme (1575-1624), German theologian and mystical writer. He was a shoemaker by profession.<br />
                        <a name="note4" href="#4">4.</a> Christoph Schorrer, <var>Theologia ascetica</var> (Rome, 1658).<br />
                        <a name="note5" href="#5">5.</a> Father Miguel of Molinos (1628-1696), a Jesuit mystical writer whose work <var>A Spiritual Guide</var> (1675) was condemned by Pope Innocent XI. Pier Matteo Petrucci (1636-1701) was installed as Cardinal, with the title San Marcello, in 1687. His writings on mysticism - in which he defended Molinos - led to him being accused of heresy, and his works placed on the Index.<br />
                        <a name="note6" href="#6">6.</a> Michaelangelo Ricci (1619-1682), churchman and (in 1681) Cardinal; Agostino Favoriti (1624-1682), secretary to Pope Innocent XI.<br />
                <br /><br />
                        &#169; Lloyd Strickland 2009. Revised 2022
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
